export const AUD_MOBILE_REDESIGN_OBJECTCARD = 'aud_mobile_bx766_objectcard_redesign';
export const NEW_MAIN_PAGE_EXPERIMENT = 'bx_mobile_bx687_new_mainpage';

export const EXPERIMENTS: string[] = [AUD_MOBILE_REDESIGN_OBJECTCARD, NEW_MAIN_PAGE_EXPERIMENT];
